//import React from 'react'
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import CallRoundedIcon from '@mui/icons-material/CallRounded';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import MarkEmailUnreadOutlinedIcon from '@mui/icons-material/MarkEmailUnreadOutlined';
import VerifiedIcon from '@mui/icons-material/Verified';
import DoneIcon from '@mui/icons-material/Done';
import { Link } from 'react-router-dom';
import PhotoGallery from "../Photogallery";
import { uploads } from "../../config";
import { API_URL } from "../../config";

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const BeautyParlourDetails = () => {
    const { slug } = useParams(); // 👈 gets slug from URL
    const [data, setData] = useState(null);
    //const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!slug) return;

        const fetchData = async () => {
            try {
                const res = await fetch(
                    `${API_URL}/api-get-business-details.php?slug=${slug}`
                );

                const result = await res.json();
                setData(result);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                //setLoading(false);
            }
        };

        fetchData();
    }, [slug]);

    return (
        <div>
            <div className='breadcrumb'><Link to="/">Home</Link> &nbsp;:&nbsp; <Link to="/beauty-parlour">Beauty Parlour</Link> &nbsp;:&nbsp; {data?.data?.business_fullname}</div>
            <div className='ibodywrap'>
                <div className='row'>
                    <div className='col-md-3'>
                        <div className='bd-left-panel sticky-position fade-in'>
                            <div className='imgbox'>
                                {data?.data?.business_logo && (
                                    <img src={`${uploads}/${data?.data?.business_logo}`} alt={data?.data?.business_fullname} className='fullimg' />
                                )}
                            </div>
                            <div className="contant-person">
                                Contact Person: <span>{data?.data?.user_first_name} {data?.data?.user_middle_name} {data?.data?.user_last_name}</span>
                                <a href={`mailto:${data?.data?.email}`}>{data?.data?.email}</a>
                            </div>
                            <div className='btn-box'>
                                <a href={`tel:${data?.data?.business_contactno1}`} className="contact-no"><CallRoundedIcon /> +91 {data?.data?.business_contactno1}</a>
                                <a href={`https://wa.me/${data?.data?.business_whatsappno}`} className="whatsapp"><WhatsAppIcon /> +91 {data?.data?.business_whatsappno}</a>
                                <a href={`mailto:${data?.data?.email}`} className="contact-no"><MarkEmailUnreadOutlinedIcon /> Send Enquiry</a>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-9'>
                        <div className='bd-right-panel fade-in'>
                            <div className='comp-details'>
                                <div className='logo-box'>
                                    {data?.data?.business_logo && (
                                        <img src={`${uploads}/${data?.data?.business_logo}`} alt={data?.data?.business_fullname} className='fullimg' />
                                    )}
                                </div>
                                <div className='title-box'><VerifiedIcon /> {data?.data?.business_fullname}</div>
                                <div className='location-box'><FmdGoodOutlinedIcon /> {data?.data?.business_address}, {data?.data?.business_city}, {data?.data?.business_district}, {data?.data?.business_state} - {data?.data?.business_zipcode}</div>
                            </div>
                            <div className='clr'></div>
                            <div className='devider'></div>
                            <div className='service-box'>
                                <h2>Services:</h2>
                                {data?.data?.business_services?.split(",").map((service, index) => (
                                    <div className="services" key={index}>
                                        <DoneIcon /> {service.trim()}
                                    </div>
                                ))}
                            </div>
                            <div className='clr'></div>
                            <div className='devider'></div>
                            <div className='overview-box'>
                                <h2>Overview:</h2>
                                <div dangerouslySetInnerHTML={{ __html: data?.data?.business_details, }} />
                            </div>
                            <div className='clr'></div>
                            <div className='devider'></div>
                            <div>
                                <PhotoGallery />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BeautyParlourDetails
